import React from 'react';
import classNames from 'classnames';
import Heading from "@scentregroup/ui/components/heading";
import { Link } from 'react-router-dom';
import trackClickEvent from '../../../helpers/analytics-utils/track-event';
import EventNotification from '../../event-notification';
import { CountryContext } from '../../../context';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const isService = (entries, contentTypes) => {
  if (contentTypes) {
    return contentTypes.includes('Service');
  } else {
    return entries && entries.find(entry => entry.contentTypeId === 'service');
  }
};

const showCovidNotification = (country, entries, contentTypes) => {
  if (country !== 'Australia') {
    return false;
  }

  return isService(entries, contentTypes);
};

const Spotlight = _ref => {
  let {
    className,
    children,
    heading,
    shortDescription,
    callToAction,
    alternateDesign,
    contentTypes,
    entries
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(style.Spotlight, style.evolved, {
      [style.SpotlightAlternative]: alternateDesign
    }, className),
    "data-id": "spotlight_index_Spotlight_div",
    children: [/*#__PURE__*/_jsx(Heading, {
      type: 'small',
      className: classNames(style.heading, {
        [style.headingAlternative]: alternateDesign
      }),
      "data-id": "spotlight_index_Spotlight_div_Heading",
      children: heading
    }), /*#__PURE__*/_jsx(CountryContext.Consumer, {
      children: country => /*#__PURE__*/_jsx(_Fragment, {
        children: shortDescription && showCovidNotification(country, entries, contentTypes) && /*#__PURE__*/_jsx(EventNotification, {
          className: style.notification,
          message: shortDescription,
          "data-id": "spotlight_index_Spotlight_EventNotification"
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: style.childWrapper,
      "data-id": "spotlight_index_Spotlight_div_div",
      children: children
    }), callToAction && callToAction.address && /*#__PURE__*/_jsx("div", {
      className: style.callToActionWrapper,
      "data-id": "spotlight_index_Spotlight_div_4",
      children: /*#__PURE__*/_jsx(Link, {
        className: style.CTALink,
        to: callToAction.address,
        onClick: callToAction.eventCategory ? () => trackClickEvent(callToAction.eventCategory, callToAction.eventAction, callToAction.eventLabel) : () => void {},
        "data-id": "spotlight_index_Spotlight_div_Link",
        children: callToAction.text
      })
    })]
  });
};

export default Spotlight;